import React from "react";
import ScopeOfTheLaboratory_Form from "./scopeOfTheLaboratory_Form/ScopeOfTheLaboratory_Form";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import ScopeOfTheLaboratory_table from "./scopeOfTheLaboratory_table/ScopeOfTheLaboratory_table";

function ScopeOfTheLaboratory() {
  return (
    <>
      <section className="Imperiality Quality_Policy ScopeOfTheLaboratory">
        <div className="back_div">
          <Common_Back_Btn backText="Scope of the Laboratory" />
        </div>
        <div className="white_container customer_section">
          {/* Note text */}
          <div className="note_text_holder">
            <p>
              Our company is committed to maintaining the highest standards of
              accuracy, reliability, and integrity in all laboratory operations.
              We ensure continuous improvement of our processes, compliance with
              quality standards, and customer satisfaction through effective
              documentation and controlled file management — including secure
              addition and deletion of files as per QMS guidelines.
            </p>
          </div>
        </div>

        <div className="imperiality_Form_div">
          <ScopeOfTheLaboratory_Form />
        </div>

        <div className="imperiality_table_div">
          <ScopeOfTheLaboratory_table />
        </div>


      </section>
    </>
  );
}

export default ScopeOfTheLaboratory;
